import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyleSheet } from 'hoc/styles';
import { Autocomplete } from 'components/Autocomplete';
import { styleSheet } from './stylesheet';

class NewsSourceTagAutocomplete extends PureComponent {
    static propTypes = {
        passedStyles: PropTypes.objectOf(PropTypes.any),
        styles: PropTypes.objectOf(PropTypes.any).isRequired,
        options: PropTypes.arrayOf(PropTypes.object).isRequired,
        initialSearchTerm: PropTypes.string,
        label: PropTypes.string,
        loading: PropTypes.bool.isRequired,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        placeholder: PropTypes.string.isRequired,
        value: PropTypes.string
    };

    static defaultProps = {
        passedStyles: {},
        initialSearchTerm: null,
        label: null,
        value: null
    };

    render() {
        const {
            passedStyles,
            styles,
            options,
            initialSearchTerm,
            label,
            loading,
            name,
            onChange,
            placeholder,
            value
        } = this.props;
        return (
            <Autocomplete
                styles={{ ...styles.container, ...passedStyles }}
                options={options}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                name={name}
                loading={loading}
                label={label}
                initialSearchTerm={initialSearchTerm}
            />
        );
    }
}

export const NewsSourceTagAutocompleteUI = compose(withStyleSheet(styleSheet))(NewsSourceTagAutocomplete);
